




















































































import ConfiguracionesGeneralesService from "@/api/ConfiguracionesGeneralesService";
import Vue from "vue";

export default Vue.extend({
  metaInfo: {
    title: "Configuraciones Generales"
  },
  name: "Generales",
  data() {
    return {
      dialog: false,
      defaultSwalProps: {
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 3000,
        icon: "success",
        title: "Mensaje",
        text: ""
      },
      headers: [
        { text: "Categoria Configuracion", value: "categoria" },
        { text: "Descripcion", value: "descripcion"},
        { text: "Valor", value: "valor" },
        { text: "Fecha Creacion", value: "createDate" },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      datos: [],
      item: {
        id: null
      },
      editedItem: {
        id: null,
        categoria: "",
        descripcion: "",
        valor: ""
      }
    };
  },
  mounted() {
   console.log("Mounted Generales.vue");
    this.getAll();
    this.setDefaultItem();
  },
  methods: {
    getAll() {
      ConfiguracionesGeneralesService.getAll()
        .then(response => {
          console.log("Data fetched successfully:", response);
          this.datos = response;
        })
        .catch(error => {
          console.error("Error fetching data:", error);
        });
    },
    editItem(item: any) {
      this.editedItem = item;
      this.dialogChange(true);
    },
    close() {
      this.dialogChange(false);
    },
    save() {
      ConfiguracionesGeneralesService.modificarConfiguracion(this.editedItem.id, this.editedItem.categoria, this.editedItem.valor, this.editedItem.descripcion)
        .then(response => {
          this.$swal({
            ...this.defaultSwalProps,
            icon: "success",
            text: "Configuracion actualizada con exito"
          });
          this.getAll();
        })
        .catch(error => {
          console.error(error);
          this.$swal({
            ...this.defaultSwalProps,
            icon: "error",
            text: "Error al actualizar la configuracion"
          });
        }).finally(() => {
          this.close();
        });
    },
    dialogChange(value: boolean) {
      this.dialog = value;
    },
    setDefaultItem() {
      const newDto = {
        id: null
      };
      this.item = newDto;
    },
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === false) {
        this.setDefaultItem();
      }
    }
  }
});
